import React from 'react';
import { ProductThumb, ThumbImage } from 'selectedMenu/components';
import { StyledButton } from 'selectedMenu/ProductThumbnail';
import styled from 'styled-components';
import { HelpLinesComponentVisible, ShapeTypeEnum } from '@inter-ikea-storageone/range';
import { useSelector } from 'react-redux';
import { helpLinesShape } from 'ducks/helpLines';
import NoneOptionImage from 'components/ProductSidebar/ProductCard/NoneOptionImage';
import PlainList from 'ui/PlainList/PlainList';
import { useIntl } from 'react-intl';
import { reportSlantedWallShapeSelected } from 'analytics/reporters';
import KompisToolTip from 'ui/KompisToolTip/KompisToolTip';
import { useCore } from 'contexts/core';

const List = styled(PlainList)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  min-height: 125px;
  margin: 0;
  padding-left: 0;
  position: relative;
`;

const SelectedShape = styled.div`
  position: absolute;
  bottom: 0;
  background-color: black;
  height: 2px;
  width: 75%;
`;

const StyledNoneOptionImage = styled(NoneOptionImage)`
  padding: 0 0 0.5rem;
  background-color: white;
  width: 56px;
  height: 56px;
`;

const StyledStyledButton = styled(StyledButton)`
  width: 65px;
  height: 70px;
`;

type ShapeListType = {
  shapes: {
    img: string;
    shapeType: ShapeTypeEnum;
    tooltipText: string;
  }[];
  onSelect: (shapeType: ShapeTypeEnum) => void;
  ariaLabelledBy: string;
};

const ShapeList = ({ shapes, onSelect, ariaLabelledBy }: ShapeListType) => {
  const currentShape = useSelector(helpLinesShape);

  const { formatMessage } = useIntl();
  const coreApi = useCore();
  const scene = coreApi.entities.getScene();
  const helpLinesVisible = scene?.getComponent<HelpLinesComponentVisible>(
    HelpLinesComponentVisible.id
  )?.visible;

  return (
    <List ariaLabelledBy={ariaLabelledBy}>
      <ProductThumb
        role="listitem"
        onClick={() => {
          reportSlantedWallShapeSelected({ shape: ShapeTypeEnum.off, menu: 'roomConfig' });

          onSelect(ShapeTypeEnum.off);
        }}
        key={'helplines-shape-none'}
      >
        <KompisToolTip
          text={formatMessage({
            id: 'storageone.wallSpaceToggle'
          })}
          uniqueId={'helplines-none-option'}
        >
          <StyledStyledButton>
            <StyledNoneOptionImage />
          </StyledStyledButton>
        </KompisToolTip>
        {currentShape === ShapeTypeEnum.off && <SelectedShape />}
      </ProductThumb>
      {shapes.map(shape => {
        const shapeKey = 'shape_' + shape.shapeType;
        return (
          <ProductThumb
            role="listitem"
            onClick={() => {
              onSelect(shape.shapeType);
            }}
            key={shapeKey}
          >
            <KompisToolTip text={shape.tooltipText} uniqueId={'helplines_shape_' + shapeKey}>
              <StyledButton aria-label={shape.tooltipText} style={{ padding: 0 }}>
                <ThumbImage src={shape.img}></ThumbImage>
              </StyledButton>
            </KompisToolTip>
            {helpLinesVisible && currentShape === shape.shapeType && <SelectedShape />}
          </ProductThumb>
        );
      })}
    </List>
  );
};

export default ShapeList;
